const en = {
  NAV_HOME: 'Home',
  NAV_ABOUT: 'About',
  NAV_RESULT: 'See results',

  HOME_INTRO_1: 'Can\'t decide with your friends which weekend would you like to go to at Primavera Sound 202X2!?',
  HOME_INTRO_2: 'We get it.',
  HOME_INTRO_3: 'Here\'s a little help.',
  HOME_INPUT_LABEL: 'Your friend’s group name',
  HOME_BUTTON_LABEL: 'Start',

  ABOUT_INTRO: 'The lineup for Primavera Sound 2022 Barcelona - Sant Adrià is not only the best in our history. It is also the biggest, the most eclectic, the most impressive, the most stellar. The most Primavera.  An extraordinary edition that is explained by the combination of the two years without a festival that we have had to face and the desire to celebrate the 20th anniversary of Primavera Sound as it deserves to be celebrated.',
  ABOUT_MORE_INFO: 'More info at',
  ABOUT_MORE_INFO_URL: 'https://www.primaverasound.com/',

  VOTE_YOUR_NAME: 'Name',
  VOTE_CHOOSE_ONE: 'Which weekend do you want to go to?',
  VOTE_BUTTON_LABEL: 'Vote',
  
  RESULT_VOTED: 'You voted',
  RESULT_CHOSE_SINGULAR: 'has chosen this weekend.',
  RESULT_CHOSE_PLURAL: 'has chosen this weekend.',
  RESULT_SHARE_URL: 'Share this URL with your friends to vote.',
  RESULT_NOBODY: 'Nobody',

  ERROR_MIN_LENGHT_1: 'Name must have more than 1 character',
  ERROR_NO_OPTION: 'You have to select an option',

  OPTION_1: '1ST WEEKEND',
  OPTION_2: '2ND WEEKEND',
  OPTION_3: '1ST WEEKEND + 2ND WEEKEND',

  SHARE_MODAL_TITLE: 'Share on:',
  SHARE_EMAIL_TITLE: 'VOTE YOUR WEEKEND',
  SHARE_QUOTE: 'Can\'t decide with your friends which weekend would you like to go to at Primavera Sound 202X2!? We get it. Here\'s a little help.',
}

export default en